import * as types from './actionTypes.js'

import { loadData } from './api.js'

import { updateUrl } from './router.js'

import {
    selectLastActiveModal, 
    selectIsModalActive,
    selectDataEndpoint,
    selectKeywordEndpoint,
    selectKeywordValue,
    selectQueryObject
} from './selectors.js'


export function initiateKeywordText () {
    return (dispatch, getState) => {
        var state = getState()
        var keywordValue = selectKeywordValue(state)
        dispatch(changeKeywordText(keywordValue))
    }
}


/**
 * Thunk Pattern, immediately dispatches the POST_INIT_DATA_FETCH action
 * then executes ajax request to load data, finally dispatching the
 * POST_INIT_DATA_RECEIVE action with the request data.
 */
export function initiateFetchPostInitData () {
    return (dispatch, getState) => {
        var state = getState()
        
        var url = selectDataEndpoint(state)

        // when this function is called we will immediately 
        // dispatch that the fetch request has been initiated
        dispatch(fetchPostInitData())

        // execute ajax request and save promise
        //
        var fetchPromise = loadData(url)
        .then(data => dispatch(receivePostInitData(data)))
        .then(() => dispatch(initiateFetchKeywordData()))

        // just to be clear :)
        return fetchPromise
    }
}


export function fetchPostInitData (queryString) {
    return {
        type: types.POST_INIT_DATA_FETCH,
        payload: queryString
    }
}


export function receivePostInitData (data) {
    return {
        type: types.POST_INIT_DATA_RECEIVE,
        payload: data 
    }
}


export function initiateFetchKeywordData () {
    return (dispatch, getState) => {
        var state = getState()
        
        var url = selectKeywordEndpoint(state)

        // when this function is called we will immediately 
        // dispatch that the fetch request has been initiated
        dispatch(fetchKeywordData())

        // execute ajax request and save promise
        //
        var fetchPromise = loadData(url)
        .then(data => dispatch(receiveKeywordData(data)))

        // just to be clear :)
        return fetchPromise
    }
}


export function fetchKeywordData (queryString) {
    return {
        type: types.KEYWORD_DATA_FETCH,
        payload: queryString
    }
}


export function receiveKeywordData (data) {
    return {
        type: types.KEYWORD_DATA_RECEIVE,
        payload: data 
    }
}


export function openModal (modalId) {
    return {
        type: types.MODAL_OPEN,
        payload: modalId
    }
}


export function closeModal () {
    return {
        type: types.MODAL_CLOSE,
        payload: null 
    }
}


export function openLastModal () {
    return (dispatch, getState) => {    
        const state = getState();
        const lastActiveModal = selectLastActiveModal(state)

        dispatch({
            type: types.MODAL_OPEN,
            payload: lastActiveModal
        })
    }
}


/**
 * If the filters or sorts have been modified, fetch new results
 * also close any modals. 
 */
export function closeModalAndFetchResults () {
    return (dispatch, _getState) => {
        dispatch(closeModal())

        // dispatch(initiateFetchResults())
    }
}


/**
 * Dispatch the SORT_CHANGE action, as well as the CLOSE_MODAL
 * action.
 */
export function changeSort (newSortId) {
    return (dispatch, getState) => {
        const state = getState();
        const isModalActive = selectIsModalActive(state)

        if (isModalActive) {
            dispatch(closeModal())
            //dispatch(initiateFetchResults())
        }

        dispatch({
            type: types.SORT_CHANGE,
            payload: newSortId 
        })
    }
}


/**
 * Modifies the url, which will trigger content update
 * in other components.
 * xxx consider renaming
 */
export function initiateFetchResults () {
    return (dispatch, getState) => {
        var state = getState()
        var queryObj = selectQueryObject(state)

        updateUrl(queryObj)
    }
}


export function toggleFilter (filterId) {
    return {
        type: types.FILTER_TOGGLE,
        payload: filterId
    }
}


export function toggleNesting (filterId) {
    return {
        type: types.NESTING_TOGGLE,
        payload: filterId
    }
}


export function deactivateAllFilters () {
    return (dispatch, _getState) => {
        dispatch({
            type: types.ALL_FILTERS_DEACTIVATE,
            payload: null
        })
        // dispatch(initiateFetchResults())
    }
}


/*
 * Will deactivate any active filters
 * that have same `context` prop
 */
export function deactivateFilterContext (contextId) {
    return {
        type: types.FILTER_CONTEXT_DEACTIVATE,
        payload: contextId
    }
}


/*
 * Will deactivate any active filters
 * that have same `paramName` prop
 */
export function deactivateFilterGroup (paramName) {
    return (dispatch, _getState) => {
        dispatch({
            type: types.FILTER_GROUP_DEACTIVATE,
            payload: paramName
        })
        // dispatch(initiateFetchResults())
    }
}

/**
 * Toggle the specified filter and initiate results request
 */
export function pushFilter (filter) {
    return {
        type: types.FILTER_PUSH,
        payload: filter
    }
}

export function replaceFilter (filter) {
    return {
        type: types.FILTER_REPLACE,
        payload: filter
    }
}

/**
 * Toggle the specified filter and initiate results request
 */
export function executeFilter (filterId) {
    return (dispatch, _getState) => {
        // Activate or deactivate the filter
        dispatch(toggleFilter(filterId))

        // then request new results
        dispatch(initiateFetchResults())
    }
}

/**
 * Toggle the specified filter and initiate results request
 */
export function addAndExecuteFilter (filter) {
    return (dispatch, _getState) => {
        // Activate or deactivate the filter
        dispatch(pushFilter(filter))

        // then request new results
        //dispatch(initiateFetchResults())
    }
}


/**
 * Toggle the specified filter and initiate results request
 */
export function replaceAndExecuteFilter (filter) {
    return (dispatch, _getState) => {
        // Activate or deactivate the filter
        dispatch(replaceFilter(filter))

        // then request new results
        //dispatch(initiateFetchResults())
    }
}



export function changeKeywordText (text) {
    return {
        type: types.KEYWORD_TEXT_CHANGE,
        payload: text
    }
}


export function searchKeywordText (text) {
    return (dispatch, _getState) => {
        dispatch({
            type: types.KEYWORD_TEXT_SEARCH,
            payload: text
        })

        dispatch(closeModal())
        // dispatch(initiateFetchResults())
    }
}


export function completeKeywordMatch (filterId) {
    return (dispatch, _getState) => {
        dispatch({
            type: types.KEYWORD_MATCH_COMPLETE,
            payload: filterId
        })

        dispatch(closeModal())
        // dispatch(initiateFetchResults())
    }
}
